// Photography used by the redesigned pages, by original asset filename
// (resolved with assetUrl / imageProps). All are Xeratec's own images from
// the live site. The hero still (public/assets/hero-jobsite.jpg) is a frame of
// the live hero video.
import { base } from "../lib/links";

export const images = {
  heroJobsite: base + "assets/hero-jobsite.jpg",
  teamGroup: "DSC_1803-scaled-e1722967315670-1536x862.jpg",
  teamMeeting: "DSC05507-3-scaled.jpg",
  dumpTruck: "R5__8363.jpg",
  someroScreed: "S15R-06-scaled-1.jpg",
  dieselTablet: "DieselTablet2-All.webp",
  norcoFleet: "image_original.webp",
  norcoTruck: "Norco_treater_haul_pic_original-1536x1024.webp",
  burnsDirt: "1752854103933.jpeg",
  michelsWeld: "person-welding-pipe-2400x1350-1-2048x1152-1-1536x864.webp",
  fieldTablet: "loadtraxx2.jpg",
  houghton: "Houghton_2019_Aerial-1536x862.jpg",
  bridge: "Xeratec-Bridge-1536x234.png",
  ebookCover: "Resource-Forecasting-768x1086.png",
};

/** Keweenaw photos shown on the live careers page, in live order. */
export const keweenawGallery = [
  "Houghton_2019_Aerial-scaled.jpg",
  "image.jpeg",
  "LoveWinterPortageLake.jpg",
  "Keweenaw-Peninsula-Sunset_@state_of_mind_photos.jpg",
  "1fb1599f2bfd138bc58bd9813238cdd6.jpg",
  "three-snowmobiles-riding-through-the-woods.jpg",
];

/** Home page case-study cards use these photos (as in the approved design). */
export const featuredCasePhotos = {
  "/norco-transport-driving-efficiency-across-every-load/": images.norcoTruck,
  "/burns-dirt-bidding-dirt-moving-smarter/": images.burnsDirt,
  "/michels-corporation-driving-growth-with-strategic-guidance-and-process-optimization/":
    images.michelsWeld,
};
